import { Grid } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled(Grid).attrs({ container: true })<{ beamerIsVisible: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  margin-right: ${props => props.beamerIsVisible ? "4.5rem" : "1rem"} ;

  color: #FFF;
  font-size: 0.9rem;
  font-family: 'Poppins Regular';
`;
